import { create } from "zustand";

/**
 * Studio drawer state — top-right brand-pill that opens the Modes / Brand /
 * Voice tabbed configurator. Mutex with `userMenuStore` so the two top-right
 * drawers never overlap. The mutex is wired *consumer-side* (in
 * `userMenuStore`) to avoid a circular import.
 */
/**
 * Studio tabs (May 23, 2026 IA cleanup). Templates added here because
 * they're rare meta-config, not daily workspace work. Avatar drawer no
 * longer surfaces Templates.
 */
export type StudioTab = "modes" | "brand" | "voice" | "templates";

interface StudioState {
  isOpen: boolean;
  activeTab: StudioTab;
  /** Mode/template/voice id selected but not yet committed (preview). */
  selectedId: string | null;
  open: () => void;
  close: () => void;
  setTab: (tab: StudioTab) => void;
  selectId: (id: string | null) => void;
}

export const useStudioStore = create<StudioState>()((set) => ({
  isOpen: false,
  activeTab: "modes",
  selectedId: null,
  open: () => set({ isOpen: true }),
  close: () => set({ isOpen: false, selectedId: null }),
  setTab: (tab) => set({ activeTab: tab, selectedId: null }),
  selectId: (id) => set({ selectedId: id }),
}));
